import axios from 'axios';


let configObj = {
	// baseURL : 'http://218.23.36.18:8100/', //服务器
	// baseURL: 'http://218.23.36.18:8110/',  //182服务器
  // baseURL: 'http://218.23.36.18:6004/',     //229服务器
    baseURL: 'http://39.98.255.243:6004/',     //129服务器
	// baseURL : 'http://172.16.1.202:8100/mos-security/',     //陈启洋
	// baseURL: 'http://172.16.3.162:8100/', //孙劲朋
	// baseURL: 'http://172.16.1.225:8100/', // 苏梦杰
//   baseURL : 'http://172.16.1.148:8100/', // 系统配置地址
  // baseURL : 'http://172.16.1.148:8055/', // 系统配置地址
};

let axiosObj = axios.create(configObj);


// request
axiosObj.interceptors.request.use((config) => {
	config.headers = {
		token: '',
		// authorization: localStorage.getItem("token") ? ' Bearer ' + localStorage.getItem("token") : 'Basic YWRtaW46YWRtaW5fc2VjcmV0'
	};

	// showFullScreenLoading()

	// console.error( '******************** ', config ) ;

	// publicMutations[ REQ_START_LOADING ]( state ) ; // 加载中.
	// state.isLoading = true ; // 加载中.
	// publicState.isLoading = true ; // 关闭加载.

	// console.error( config, '111111111111111111' ) ;

	// before request..
	return config;
}, (err) => {

	return err;
});

// response
axiosObj.interceptors.response.use((res) => {
	// tryHideFullScreenLoading()
	// before response...

	// publicMutations[ REQ_END_LOADING ]( state ) ; // 关闭加载.
	// state.isLoading = false ; // 关闭加载.

	// publicState.isLoading = false ; // 关闭加载.

	// console.error( res, '0000000000000000000000' ) ;

	if (+res.data.code === 401) {
		// localStorage.removeItem('token');
		// router.replace({ name: 'login' });
	}

	return res;
}, (err) => {

	// console.error( err, '2222222222222222222222222' ) ;

	if (err.code === 'ECONNABORTED' && ~err.message.indexOf('timeout')) { // 请求超时了
		console.log('请求已超时');
	}

	return Promise.reject(err);


});

let needLoadingRequestCount = 0

export function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		// state.isLoading = true ; // 加载中.
		// publicState.isLoading = true ; // 关闭加载.
	}
	needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		// state.isLoading = false ; // 关闭加载.
		// publicState.isLoading = false ; // 关闭加载.
	}
}


let _fn = (reqObj, url) => {

	if (!reqObj.url && url) {
		reqObj.url = url;
	}
	if (!reqObj.method) {

		reqObj.method = 'post';
	}

	// console.error( '请求对象: ', reqObj ) ;

	return new Promise((resolve, reject) => {
		axiosObj(reqObj)
			.then(d => {
				// console.error( 'ddddd : ', d ) ;
				resolve(d.data);
			})
			.catch(e => {
				// localStorage.removeItem('token')
				// publicState.token = null;
				// router.replace({ name: 'login' })
				reject(e);
			});
	});
}

_fn.configObj = configObj;
export default _fn;



// WEBPACK FOOTER //
// ./src/api/request.js